import { AES, enc, Rabbit } from "crypto-js";
import { Buffer } from "buffer";
import { NEXT_PUBLIC_PRIVATE_KEY } from "@/libs/constants/auth";

const isBrowser = () => typeof window !== "undefined";

const decryptAuthCode = (encryptedAuthCode: string) => {
  try {
    const buff = Buffer.from(encryptedAuthCode, "base64").toString("utf-8");
    const bytes = AES.decrypt(buff, NEXT_PUBLIC_PRIVATE_KEY);
    const originalText = bytes.toString(enc.Utf8);

    return originalText;
  } catch (error) {
    console.log("Unable to decrypt", error);
  }
};

const reEncryptAuthCode = (authCode: string) => {
  try {
    const ciphertext = Rabbit.encrypt(authCode, NEXT_PUBLIC_PRIVATE_KEY).toString();
    const buffer = Buffer.from(ciphertext).toString("base64");

    return buffer;
  } catch (error) {
    console.log("Unable to decrypt", error);
  }
};

export { decryptAuthCode, isBrowser, reEncryptAuthCode };
